export const PRODUCT_STATUS = {
  ACTIVE: 2,
  CLOSED: 3,
  CANCELLED: 7
};
